import { useEffect } from 'react';

export function useCounterPulse() {
  useEffect(() => {
    const counter = document.getElementById('fs-counter');
    if (!counter) return;

    const interval = setInterval(() => {
      counter.classList.remove('fs-counter-pulse');
      void counter.offsetWidth;
      counter.classList.add('fs-counter-pulse');
    }, 5000);

    return () => clearInterval(interval);
  }, []);
}
